import { render } from "./edit-contract.vue?vue&type=template&id=4903ca4f&scoped=true"
import script from "./edit-contract.vue?vue&type=script&lang=js"
export * from "./edit-contract.vue?vue&type=script&lang=js"

import "./edit-contract.vue?vue&type=style&index=0&id=4903ca4f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4903ca4f"]])

export default __exports__